import { useEffect, useState } from 'react'
import { CITY, TIME_ZONE } from '../constants/site'

const format = new Intl.DateTimeFormat('en-GB', {
  timeZone: TIME_ZONE,
  hour: '2-digit',
  minute: '2-digit',
  timeZoneName: 'shortOffset',
})

const Clock = () => {
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 10_000)
    return () => clearInterval(id)
  }, [])

  return (
    <time dateTime={now.toISOString()}>
      {CITY} {format.format(now)}
    </time>
  )
}

export default Clock
